<template>
  <svg
    version="1.1"
    id="Warstwa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 220.887 71.972"
    style="enable-background: new 0 0 220.887 71.972"
    xml:space="preserve"
  >
    <g>
      <g>
        <polygon
          class="st0"
          points="32.437,22.547 24.328,34.735 16.218,22.547 0,22.547 16.218,46.923 0,71.299 16.218,71.299 
			24.328,59.111 32.437,71.299 48.656,71.299 32.437,46.923 48.753,22.547 		"
        />
      </g>
    </g>
    <g>
      <path
        class="st1"
        d="M99.348,33.704H90.08v37.693H77.085V33.704h-5.829V22.89h5.829V8.715h12.899V22.89h9.364V33.704z"
      />
      <path
        class="st1"
        d="M145.976,22.89v48.507h-10.701l-1.434-5.46c-3.631,4.69-9.704,6.035-14.333,6.035
		c-4.196,0-10.829-1.328-14.714-5.982c-3.886-4.655-5.829-10.902-5.829-18.742c0-7.838,1.943-14.069,5.829-18.688
		c3.885-4.62,9.948-5.93,14.714-5.93c4.629,0,10.702,1.31,14.333,5.93l1.434-5.67H145.976z M131.023,57.065
		c2.07-2.555,3.105-5.827,3.105-9.817c0-3.989-1.035-7.261-3.105-9.816c-2.07-2.556-4.698-3.833-7.883-3.833
		c-3.186,0-5.782,1.277-7.788,3.833c-2.006,2.555-3.01,5.827-3.01,9.816c0,3.99,1.003,7.263,3.01,9.817s4.603,3.832,7.788,3.832
		C126.325,60.897,128.953,59.62,131.023,57.065z"
      />
      <path class="st1" d="M153.811,0h12.994v71.397h-12.994V0z" />
      <path
        class="st1"
        d="M204.356,71.397L187.73,49.768v21.629h-12.995V0h12.995v40.318l14.142-17.429h16.435L199.1,44.938
		l21.786,26.459H204.356z"
      />
    </g>
    <rect x="48.752" y="42.352" class="st1" width="13.594" height="9.142" />
  </svg>
</template>
<style scoped>
.st0 {
  fill: #2da837;
}
.st1 {
  fill: var(--x-talk-colorLogo);
}
</style>
